module.exports = __webpack_public_path__ + "assets/img/logo.17f8260e.png";